import { notificationApi } from "../../app/notificationApi";
import { API_URL } from "../../constants/apiUrl";
import {
  GetCommonParams,
  GetQueryArgsType,
  PatchQueryArgsType,
} from "../../types";
import {
  GetNotificationSettingType,
  GetNotificationTemplateParams,
  GetNotificationTemplatesDetailsType,
  GetNotificationTemplatesType,
  GetNotificationType,
} from "../../types/notification";

export const announcementApi = notificationApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<
      GetNotificationType,
      GetQueryArgsType<GetCommonParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getNotifications,
        ...queryArgs,
      }),
      providesTags: ["GetNotifications"],
    }),
    notificationStatus: builder.mutation({
      query: (data) => ({
        url: `${API_URL.notificationStatus}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetNotifications"];

        return [];
      },
    }),
    getNotificationSetting: builder.query<
      GetNotificationSettingType,
      GetQueryArgsType<GetCommonParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getNotificationSetting,
        ...queryArgs,
      }),
      providesTags: ["GetNotificationSetting"],
    }),
    createNotificationSetting: builder.mutation({
      query: (data) => ({
        url: `${API_URL.createNotificationSetting}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetNotificationSetting"];

        return [];
      },
    }),
    getNotificationTemplates: builder.query<
      GetNotificationTemplatesType,
      GetQueryArgsType<GetNotificationTemplateParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getNotificationTemplates,
        ...queryArgs,
      }),
      providesTags: ["GetNotificationTemplates"],
    }),
    getNotificationTemplatesDetails: builder.query<
      GetNotificationTemplatesDetailsType,
      number
    >({
      query: (id) => ({
        url: `${API_URL.getNotificationTemplatesDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [
        { type: "GetNotificationTemplatesDetails", id },
      ],
    }),
    createNotificationTemplates: builder.mutation({
      query: (data) => ({
        url: `${API_URL.createNotificationTemplates}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetNotificationTemplates"];

        return [];
      },
    }),
    updateNotificationTemplates: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateNotificationTemplates}/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetNotificationTemplates",
            { type: "GetNotificationTemplatesDetails", id },
          ];

        return [];
      },
    }),
    updateNotificationTemplatesStatus: builder.mutation<
      unknown,
      PatchQueryArgsType
    >({
      query: ({ body, id }) => ({
        url: `${API_URL.updateNotificationTemplatesStatus}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetNotificationTemplates",
            { type: "GetNotificationTemplatesDetails", id },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useNotificationStatusMutation,
  useCreateNotificationSettingMutation,
  useGetNotificationSettingQuery,
  useCreateNotificationTemplatesMutation,
  useGetNotificationTemplatesQuery,
  useGetNotificationTemplatesDetailsQuery,
  useUpdateNotificationTemplatesMutation,
  useUpdateNotificationTemplatesStatusMutation,
} = announcementApi;
